










import { Component, Prop, Vue } from 'vue-property-decorator'
import { closeAll } from '@ivy/fts/showDiv'
import { env } from '@ivy/fts/envInfo/envInfo'
import openApp from '@ivy/fts/openApp'

@Component({
  components: {},
})
export default class ChooseGiftDialog extends Vue {
  openVip() {
    if (env.type === 'ivydad') {
      env.commonJump('ivydadreadtool://my/vip')
    } else {
      openApp()
    }
  }

  close() {
    window.modals[window.modals.length - 1].close()
  }
}
